var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-selector"},[_c('v-select',{attrs:{"items":_vm.views,"filled":"","label":"View","dense":""},model:{value:(_vm.view),callback:function ($$v) {_vm.view=$$v},expression:"view"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }